import mainCaller from './mainCaller';

export async function getAppVersions(token) {
  return await mainCaller('admin/api/v1/system/versions', 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateAppVersion(id, data, token) {
  return await mainCaller(`admin/api/v1/system/versions/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}
